import { createApp,reactive } from "vue";
import creatLoading from "./creatLoading.vue";


const divDom = document.createElement('div')


divDom.setAttribute('class','loading-container')


const options = reactive({
    showToast: true,
    txt: 'Loading...',
    num: 0,
    len: 0,
})


const $creatLoading = createApp(creatLoading,{options}).mount(divDom)


const loadPlguin = {
    show({txt,len}) {
        options.showToast = true
        options.txt = txt || 0
        options.len = len || 0
        document.body.appendChild($creatLoading.$el)
    },
    hide() {
        options.showToast = false
        options.num = 0
        options.len = 0
    },
    changeProgress(num) {
        options.num = num
    }
}


export default {
    install(app) {
        app.config.globalProperties.$creatLoading =  loadPlguin 
    }
}

